"use strict";

import * as App from '../app/app~fv=cw_byBD8.min.js';
import * as Lib from '../lib/lib~fv=LNbMt1n5.min.js';
import * as Highlight from '../page/coze_verifier_highlight~fv=Q0bSPAKM.min.js';
import * as Coze from '../pkg/coze_all~fv=-7uCIHNa.min.js'; // Must import coze_all for coze array function.  
import '../pkg/urlform~fv=VhWyOSvq.min.js'; // Namespaced as 'URLForm'.
import QrScanner from '../pkg/qr-scanner.min.js'

/**
@typedef {import ('../../../pkg/urlformjs/urlform.js').FormParameters} FormParameters
@typedef {import('../../../pkg/cozejs/key.js').CozeKey}                CozeKey
 */

// URLFormJS sticky form
/**@type {FormOptions} */
const FormOptions = {
	"FormParameters": [{
			"name": "input",
			"id": "message",
		},
		{
			"name": "private", // Private mode
			"id": "privateMode",
			"type": "bool",
			"funcTrue": () => privateMode = true,
		},
		{
			"name": "dontSignRevoke", // Do not sign messages that contain `rvk`
			"type": "bool",
			"defaultValue": true,
		},
		{
			"name": "updateIat", // Update `iat` when signing a message
			"type": "bool",
			"defaultValue": true,
		},
		{
			"name": "key",
			"id": "keyArea",
		},
		{
			"name": "selectedAlg",
			"func": function (value) {
				SetSelectedAlg(value);
			},
			"defaultValue": "ES256", // TODO fix this in URLFormJS so URLFormJS omits parameter from share if the same value as default. 
		},
		{
			"name": "advanced",
			"type": "bool",
			"funcTrue": () => document.getElementById("advancedBtn").click(),
			// "nonFormValue": true,
		},
		// Import must be before Verify so that imported keys can be used for verify.  
		{
			"name": "import", // Typically use Verify instead since it also imports the key.  
			"type": "bool",
			"funcTrue": async function () {
				// console.debug("import")
				//await ImportKey(JSON.parse(URLForm.GetQuagParts(initedFormOptions).pairs.key))
				let key = URLForm.GetQuagParts(initedFormOptions).pairs.key
				if (!isEmpty(key)) {
					document.querySelector("#keyArea").value = key
					await ImportKey()
				}
			},
			// "nonFormValue": true,
		},
		{
			"name": "verify",
			"type": "bool",
			"funcTrue": async function () {
				await VerifyCoze()
			},
		},

		{
			"name": "pretty",
			"type": "bool",
			"funcTrue": () => jsonSpaces(4),
		},
		{
			"name": "block",
			"type": "bool",
			"funcTrue": () => jsonSpaces(0),
		},
	]
};
var initedFormOptions = {}; // URLFormJS.FormOptions after being inited by `URLFormJS.Init(FormOptions)`

// The global Coze Key used for all signing and verifying.  If set the default
// is App.Coze key, and it can be replaced with imported key, by retrieving, and
// by coze.key.
var CozeKey = {};

// Metadata
var Alg;
var Iat;
var Iats; // iat as a string.
var Tmb;
var Typ;
var Can;
var Cad;
var Sig;
var Czd;

// Spaces is the default number of spaces for JSON indentation.
var Spaces = 4;

// privateMode does not send any requests to the server. This may be a security
// concern for verification since revoked keys cannot be checked. When true, any
// calls related to verification should be the user warning that revokes are not
// being checked.
var privateMode = false;
var dontSignRevoke = true;
var updateIat = true;
var selectedAlg = "";

let scanQRModal;

const verifiedIcon = `<img src="/assets/img/icons/check_128_128.png" alt="verified" class="msgIcon">`;
const failIcon = `<img src="/assets/img/icons/x_128_128.png" alt="fail" class="msgIcon">`;

var KeyLocations = {
	"CozeKeyApp": {
		locationTitle: "", // kid is title.
		// Assume key is good and don't attempt retrieval. (Key loads on app load) 
		attemptRetrieval: false,
		verifiedMsg: "Message verified using your key."
	},
	"CozeKeyNew": {
		locationTitle: "New key: ",
		attemptRetrieval: false, // New keys are not on the system. 
		verifiedMsg: "Message verified using key generated on this page."
	},
	"CozeKeyRetrieved": {
		locationTitle: "Retrieved key: ",
		attemptRetrieval: false,
		verifiedMsg: "Message verified using key retrieved from servers looked up by \"tmb\"."
	},
	"CozeKeyFromMessage": {
		locationTitle: "Key from coze: ",
		attemptRetrieval: true,
		verifiedMsg: "Message verified using key from inside message."
	},
	"CozeKeyTmbOnly": {
		locationTitle: "tmb only key: ",
		attemptRetrieval: true,
		verifiedMsg: "" // Not possible to verify with tmb
	},
	"CozeKeyImported": {
		locationTitle: "Imported key: ",
		attemptRetrieval: true,
		verifiedMsg: "Message verified using imported key."
	},
}

App.AddOnload(Onload);
async function Onload() {
	// Details elements
	Alg = document.querySelector("#alg");
	Iat = document.querySelector("#iat");
	Iats = document.querySelector("#iats");
	Tmb = document.querySelector("#tmb");
	Typ = document.querySelector("#typ");
	Can = document.querySelector("#can");
	Cad = document.querySelector("#cad");
	Sig = document.querySelector("#sig");
	Czd = document.querySelector("#czd");

	document.querySelector("#signMessageBtn").addEventListener('click', SignMsgGUI);
	document.querySelector("#signRawBtn").addEventListener('click', SignRawJSONGUI);
	document.querySelector("#verifyMessageBtn").addEventListener('click', () => VerifyCoze());
	document.querySelector("#removeSpacesBtn").addEventListener('click', () => jsonSpaces(0));
	document.querySelector("#spacesBtn").addEventListener('click', () => jsonSpaces(4));
	document.querySelectorAll('.newKeyBtn').forEach((e) => e.addEventListener('click', NewKey));
	document.querySelector('#importKeyBtn').addEventListener('click', ImportKey);
	document.querySelector("#advancedBtn").addEventListener('click', () => ToggleVisible(AdvancedDiv));

	// // Set GUI state (disable sign buttons when CozeKey is empty)
	// await ResetGUI();

	// Shift + Enter trigger VerifyCoze  
	document.querySelector("#message").addEventListener('keydown', function (event) {
		if (event.code == "Enter" && event.shiftKey) {
			event.preventDefault();
			VerifyCoze();
		}
	});
	document.querySelectorAll('.copyOutputBtn').forEach(function (item) {
		item.addEventListener('click', function () {
			ClipboardE(document.getElementById("signedMessage"));
			App.Notification("Copied.", "success");
		});
	});
	document.querySelector("#showPrivateKeyBtn").addEventListener('click', function () {
		ToggleVisible("privateKeyDiv");
	});
	document.querySelector("#publicKeyCopyBtn").addEventListener('click', function () {
		ClipboardE(document.getElementById("publicKeyDisplay"));
		App.Notification("Copied.", "success");
	});

	document.querySelector("#privateKeyCopyBtn").addEventListener('click', function () {
		ClipboardE(document.getElementById("privateKeyDisplay"));
		App.Notification("Copied.", "success");
	});

	// Page toggles
	let pmElem = document.querySelector("#privateMode")
	pmElem.addEventListener('click', function (event) {
		if (pmElem.checked) {
			privateMode = true;
		} else {
			privateMode = false;
		}
	});
	let uiElem = document.querySelector("#updateIat")
	uiElem.addEventListener('click', function () {
		if (uiElem.checked) {
			updateIat = true;
		} else {
			updateIat = false;
		}
	});
	let dsrElem = document.querySelector("#dontSignRevoke")
	dsrElem.addEventListener('click', function () {
		if (dsrElem.checked) {
			dontSignRevoke = true;
		} else {
			dontSignRevoke = false;
		}
	});
	// Trigger events so any manipulation by URLFormJS is in effect.  
	pmElem.dispatchEvent(new Event("click"))
	dsrElem.dispatchEvent(new Event("click"))
	uiElem.dispatchEvent(new Event("click"))

	document.querySelectorAll('.selectedAlg').forEach(function (item) {
		item.addEventListener('change', function () {
			SetSelectedAlg(this.value)
		})
	})
	// Set ID on the first one instance so URLFormJS can set the value in the URL. 
	document.querySelector('select[name="selectedAlg"]').id = "selectedAlg"
	document.querySelector("#customShareURLBtn").addEventListener('click', async function () {
		await jsonSpaces(0); // Remove spaces so links are smaller. 
		URLForm.ShareURI(initedFormOptions);
	})
	document.querySelectorAll(".clearAllBtn").forEach(function (item) {
		item.addEventListener('click', function () {
			URLForm.Clear(initedFormOptions)
			ResetGUI()
		});
	});


	if (!isEmpty(App.CozeKey)) {
		App.CozeKey.fromLocation = "CozeKeyApp";
		await SetSelectedCozeKey(App.CozeKey);
	}



	// Modals
	let modalOpts = {
		keyboard: true
	};

	scanQRModal = new bootstrap.Modal(document.getElementById('scanQRModal'), modalOpts);
	document.querySelector(".scanQRBtn").addEventListener("click", ScanQRModal);


	// Enable tooltips
	// TODO seems to have a bug.
	// var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	// var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
	// 	return new bootstrap.Tooltip(tooltipTriggerEl)
	// });


	////////////////
	// Dragster
	////////////////
	let dropzone = document.getElementById("file_drop_area");
	let dragster = new App.Dragster(dropzone);

	document.addEventListener("dragster:enter", function (e) {
		e.target.classList.add("highlight");
	}, false);
	document.addEventListener("dragster:leave", function (e) {
		e.target.classList.remove("highlight");
	}, false);

	// Handle dropped files
	dropzone.addEventListener('drop', (e) => {
		HandleFiles(e.dataTransfer.files)
	}, false);

	document.querySelector("#fileUploadBtn").addEventListener('click', function () {
		this.parentElement.querySelector(".fileUploadInput").click();
	});

	// Trigger the file upload event from the GUI File Selection.
	document.querySelector(".fileUploadInput").onchange = function () {
		let files = document.querySelector(".fileUploadInput").files;
		HandleFiles(files);
	};

	function preventDefaults(e) {
		e.preventDefault();
		e.stopPropagation();
	};

	// Prevent default drag behaviors.
	// For unknown reasons dragover is yanking the drop event it's not stopped.
	// dragenter and dragleave are just for extra measure.    
	['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
		//dropzone.addEventListener(eventName, preventDefaults, false);
		document.body.addEventListener(eventName, preventDefaults, false);
	});

	// Set sticky options on the page via URL.
	initedFormOptions = URLForm.Init(FormOptions)
	URLForm.Populate(initedFormOptions);
};

// SetSelectedAlg sets the global selected alg and displays the selected alg on
// the GUI.
function SetSelectedAlg(alg) {
	//console.log("SetSelectedAlg", alg);
	if (alg == "") {
		console.log("SetSelectedAlg alg empty.  Using ES256");
		alg = "ES256"
	}
	selectedAlg = alg
	document.querySelector(".selectedHashAlg").textContent = selectedAlg;
	document.querySelector(".selectedHashAlgHash").textContent = Coze.HashAlg(selectedAlg);

	// Keep all instances on the same value. 
	document.querySelectorAll('.selectedAlg').forEach(function (item) {
		item.value = selectedAlg
	})
}

/**
NewKey generates a new key, sets `CozeKey`, and set the GUI appropriately.
 */
async function NewKey() {
	try {
		// console.debug("Generating a new Coze key with alg: " + selectedAlg);
		var key = await Coze.NewKey(selectedAlg);
	} catch (e) {
		console.error(e);
		MessageSucceedFail("verified", e, "", false);
	}
	key.fromLocation = "CozeKeyNew"
	await SetSelectedCozeKey(key);
};

/**
ImportKey grabs the key from the input key area and updates the GUI
appropriately.
 */
async function ImportKey() {
	console.log("Import Key");
	let k = document.querySelector("#keyArea").value;
	if (isEmpty(k)) {
		console.log("No key to import");
		return;
	}

	let key = JSON.parse(k)
	key.fromLocation = "CozeKeyImported";
	await SetSelectedCozeKey(key);
};


/**
jsonSpaces sets spaces (pretty) on the input (#message) and output
(#signedMessage).
@param   {number} spaces  Number of spaces.
 */
function jsonSpaces(spaces) {
	try { // Input Message
		let Msg = document.getElementById("message");
		if (Msg.value !== "") {
			let msgJSON = JSON.parse(Msg.value);
			Msg.value = JSON.stringify(msgJSON, null, spaces);
		}
	} catch (e) {
		console.debug(e); // Continue on error.  
	}

	try { // Signed Message
		let sMsgElem = document.getElementById("signedMessage");
		if (isEmpty(!sMsgElem.textContent)) {
			if (Highlight.EnableHighlighting) {
				sMsgElem.textContent = "";
				Highlight.HighlightCan();
			} else {
				document.getElementById('signedMessage').classList.remove('highlightGrey');
				sMsgElem.textContent = JSON.stringify(JSON.parse(sMsgElem.textContent), null, spaces);
			}
		}
	} catch (e) {
		console.debug(e); // Continue on error.  
	}

	try { // Public Key Display
		let pukKeyElem = document.getElementById("publicKeyDisplay")
		if (!isEmpty(pukKeyElem.textContent)) {
			pukKeyElem.textContent = JSON.stringify(JSON.parse(pukKeyElem.textContent), null, spaces);
		}
	} catch (e) {
		console.debug(e); // Continue on error.  
	}

	try { // Import Key
		let key = document.getElementById("keyArea");
		console.log("keyArea value:", key.value);
		if (key.value !== "") {
			let msgJSON = JSON.parse(key.value);
			key.value = JSON.stringify(msgJSON, null, spaces);
		}
	} catch (e) {
		console.debug(e); // Continue on error.  
	}
};


/**
ShowMeta displays the coze information on the page.  SetSelectedCozeKey
must be called first to set CozeKey global.  
@param  {coze} coze      Javascript object. May be coze or coze.pay.
 */
async function ShowMeta(coze) {
	//console.log("ShowMeta", coze);
	try {
		if (Array.isArray(coze)) { // Don't attempt for arrays.
			return;
		}

		// !! Assumes that CozeKey is the key.  TODO consider alg selection.  
		let meta = await Coze.Meta(coze, CozeKey.alg);
		Alg.textContent = meta.alg;
		Iat.textContent = meta.iat;
		Iats.textContent = "(" + new Date(meta.iat * 1000).toLocaleString() + ")";
		Tmb.innerText = meta.tmb;
		if (!isEmpty(CozeKey.link) && CozeKey.tmb == meta.tmb) {
			Tmb.innerHTML = CozeKey.tmb.link(App.Page.CozeKey + "/" + CozeKey.tmb) + " | " + "(JSON)".link(CozeKey.linkJSON);
		}
		Typ.textContent = meta.typ;
		Can.textContent = JSON.stringify(meta.can);
		Cad.textContent = meta.cad;
		Sig.textContent = meta.sig;
		Czd.textContent = meta.czd;

		Show("detailsRow");
	} catch (e) {
		console.error(e)
	}
};

// ResetGUI resets all non-user input GUI fields.  
async function ResetGUI() {
	Clear(Alg);
	Clear(Iat);
	Clear(Iats);
	Clear(Tmb);
	Clear(Typ);
	Clear(Can);
	Clear(Cad);
	Clear(Sig);
	Clear(Czd);

	Clear("verified");
	Clear("signedMessage");
	Clear("privateKeyDisplay")

	Hide("verified");
	Hide("signedMessageRow");
	Hide("detailsRow");
	Hide("Revoked");
	Hide("privateMode");
	Hide("showPrivateKeyBtn")
	Hide("privateKeyDiv")
	Hide("retrievedKeyLink")
	Hide("publicKeyDiv");

	if (isEmpty(CozeKey)) {
		Show("noUserKey");
		Disable("signMessageBtn");
		Disable("signRawBtn");
	} else {
		Hide("noUserKey");
		Enable("signMessageBtn");
		Enable("signRawBtn");
	}

	document.getElementById('signedMessage').classList.remove('highlightGrey');
};


/**
UpdateKeyGui does the following:

1. Sets the GUI to display the currently used key (var CozeKey).  
2. Sets the URL on the "currently used key".
@returns {void} 
 */
async function UpdateKeyGui() {
	ResetGUI();
	if (isEmpty(CozeKey) || isEmpty(CozeKey.tmb)) {
		console.error("CozeKey is Empty")
		return
	}
	CozeKey.title = KeyLocations[CozeKey.fromLocation].locationTitle + CozeKey.kid + " " + CozeKey.tmb.substring(0, 6) + "...";

	// key.time is used as the source of truth for "key exists in Cyphrme".
	if (!isEmpty(CozeKey.time) || CozeKey.fromLocation === "CozeKeyRetrieved") {
		CozeKey.link = App.Page.CozeKey + "/" + CozeKey.tmb
		CozeKey.linkJSON = App.API.Get.CozeKey + "/" + CozeKey.tmb + "?pretty"
		CozeKey.titleHTML = CozeKey.title.link(CozeKey.link);
	} else {
		CozeKey.titleHTML = CozeKey.title;
	}

	document.querySelectorAll('.selectedKid').forEach((item) => {
		item.innerHTML = CozeKey.titleHTML;
	});

	var sanitizeCozeKey = {
		alg: CozeKey.alg,
		iat: CozeKey.iat,
		kid: CozeKey.kid,
		rvk: CozeKey.rvk,
		tmb: CozeKey.tmb,
		x: CozeKey.x,
	}

	Show("publicKeyDiv"); // Show only the public key
	SetHTML("publicKeyDisplay", JSON.stringify(sanitizeCozeKey, null, Spaces))

	if (CozeKey.fromLocation === "CozeKeyRetrieved") { // Set GUI with retrieved key
		document.querySelector("#retrievedKeyLink").href = CozeKey.link;
		Show("retrievedKeyLink");
	}

	// Only allow showing the private key if the private key was imported or
	// generated on page.  
	if ((CozeKey.fromLocation == "CozeKeyImported" && !isEmpty(CozeKey.d)) ||
		CozeKey.fromLocation == "CozeKeyNew") {

		let sanitizePrikCozeKey = {
			alg: CozeKey.alg,
			iat: CozeKey.iat,
			kid: CozeKey.kid,
			rvk: CozeKey.rvk,
			tmb: CozeKey.tmb,
			x: CozeKey.x,
			d: CozeKey.d,
		}

		SetHTML("privateKeyDisplay", JSON.stringify(sanitizePrikCozeKey, null, Spaces))
		Show("showPrivateKeyBtn")
	}

	if (Coze.IsRevoked(CozeKey)) { // If revoked set warning.
		let msg = "⚠️ Key is revoked.";
		// Use `rvk_time`, authority time, not `rvk` which is self-signed
		if (CozeKey.rvk_time > 0) {
			msg = "⚠️ Key is revoked since " + await App.UnixToHR(CozeKey.rvk_time);
		}

		SetHTML("Revoked", msg);
		Show("Revoked");
	}
}


/**
SetSelectedCozeKey does the following:

// TODO this should be re-worked where ajax calls are split out and not handled
by this function.  

1. Sets links for keys that are in Cyphr.me. 
2. Sets key title with "Retrieved: ...", "New key: ...", etc...
3. If needed, attempts retrieval of the Coze key from Cyphr.me 
4. Displays errors 
  - if key is not found for the given tmb

CozeKeyApp          from App.CozeKey.  
CozeKeyRetrieved    key retrieved by ajax to check for `rvk`.
CozeKeyTmbOnly      tmb from coze, no public key was given so it needs retrieval.   
CozeKeyImported     key imported from the input.  
CozeKeyNew          key created by this page.  
CozeKeyFromMessage  key from the given Coze, e.g. {"pay":...,"key":{the key in here}, "sig":...}
@param   {CozeKey}  cozeKey             Key to set global CozeKey to.  
@returns {boolean}  successfully retrieved a valid key.  
 */
async function SetSelectedCozeKey(cozeKey) {
	//console.log("SetSelectedCozeKey", cozeKey)
	if (isEmpty(cozeKey.fromLocation)) {
		console.error("Key fromLocation is not set.  ")
		return false;
	}
	if (!isEmpty(cozeKey.x)) {
		cozeKey.tmb = await Coze.Thumbprint(cozeKey); // Recalculate, don't trust input. (input may be from user input).
	}
	cozeKey.attemptRetrieval = KeyLocations[cozeKey.fromLocation].attemptRetrieval;
	if (cozeKey.attemptRetrieval) {
		GetKey(cozeKey.tmb)
	}

	CozeKey = cozeKey;
	UpdateKeyGui();
}


/**
GetKey gets the Coze key for the given tmb from the server. Returns error if
server errors or response from server does not include x.
@param   {Tmb}    tmb        Key to set global CozeKey to.
@returns {error}             Empty string on no error.
 */
async function GetKey(tmb) {
	if (privateMode) {
		return "Private mode is on.  Not fetching key.";
	}

	// On error, ajaxKey will be error object, `{"success": false,"msg": "[error msg here]"}`
	let successJSON = await App.Fetch(App.API.Get.CozeKey + "/" + tmb)
	let ajaxKey = successJSON.obj
	// console.debug("GetKey ajax key:", ajaxKey)
	if (isEmpty(ajaxKey.x)) {
		if (isEmpty(ajaxKey.msg)) { // If for some reason msg from server is also empty.
			ajaxKey.msg = "There was a problem retrieving the key from the server"
		}
		return ajaxKey.msg
	}
	ajaxKey.fromLocation = "CozeKeyRetrieved"
	ajaxKey.attemptRetrieval = false // Break any potential infinite loop.

	CozeKey = ajaxKey
	UpdateKeyGui()
	return ""
}

/**
VerifyCoze verifies the input coze using the global CozeKey, sets the GUI,
retrieves public key, and returns bool.  privateMode is for checking for
revokes, and/or may be needed if the public key isn't given, but tmb is
otherwise known.
 @returns {boolean}   valid or not.
 */
async function VerifyCoze() {
	await ResetGUI();
	await SetSelectedCozeKey(CozeKey);
	let invalidMsg = "Unable to verify.  ";
	let validMsg = "Message verified.";
	let coze = {};
	if (privateMode) { // If in Private Mode show warning
		Show("privateMode")
	}

	var msg = await document.getElementById("message").value.trim(); // .trim() removes accidental whitespace.  
	//console.log("VerifyCoze", CozeKey, msg);


	// Is digest?  Callback will re-call VerifyCoze on success. (Digests don't
	// have signatures, so this function won't work otherwise.) 
	if (await App.IsCyphrmeDigest(msg)) {
		if (!privateMode) {
			var rj = await App.Fetch(App.API.Get.SearchCoze + "/" + msg);
			if (Object.keys(rj).includes('success') && rj.success == false) {
				MessageSucceedFail("verified", rj.msg, "", false);
				return false;
			}
			document.getElementById('Message').value = JSON.stringify(rj, null, Spaces);
			coze = rj;
		} else {
			MessageSucceedFail("verified", "Private mode is on. Cannot retrieve coze from digest.", "", false, true);
			return false;
		}
	} else { // If not dig, input must be JSON.
		try {
			coze = JSON.parse(msg);
		} catch (e) {
			invalidMsg = "Invalid JSON: " + e;
			console.error("Invalid JSON: ", invalidMsg);
			MessageSucceedFail("verified", invalidMsg, "", false);
			return false;
		}
	}
	await ShowMeta(coze) // Attempt ShowMeta, should be overwritten again by later checks.  

	// Is the message an array? 
	if (Array.isArray(coze)) {
		// Grab public key if needed. Assumes from first tmb.  Does not support multi-key.  
		if (coze[0].pay.tmb !== CozeKey.tmb) {
			let err = await GetKey(coze[0].pay.tmb);
			if (!isEmpty(err)) {
				MessageSucceedFail("verified", err, "", false);
				return false;
			}
		}

		let obj = await Coze.VerifyCozeArray(coze, CozeKey);
		//console.log("Verified Is Array obj:", obj);
		validMsg = "Verified all.  Count: " + obj.VerifiedCount;

		if (obj.VerifiedAll == false) {
			invalidMsg = `${invalidMsg} Fail count: ${obj.FailedCount} at [${obj.FailedPosition}]`
		}

		MessageSucceedFail("verified", invalidMsg, validMsg, obj.VerifiedAll);
		Highlight.HighlightCan();
		// TODO ShowMeta(coze); with array.
		return obj.VerifiedAll;
	}

	// Single coze (not array)
	// Is message "coze" encapsulated?
	if (!isEmpty(coze.coze)) {
		coze = coze.coze;
	}

	// Does Coze have sig?  If not, not coze. 
	if (!Object.keys(coze).includes("sig")) {
		// Is it a key?  Show massage saying to import key.  
		MessageSucceedFail("verified", `Input does not have field "sig".`, "", false);
		return false;
	}

	// Does msg have a public key?  If yes, use that key, ignore currently set
	// application key. 
	if (!isEmpty(coze.key)) {
		coze.key.fromLocation = "CozeKeyFromMessage";
		await SetSelectedCozeKey(coze.key);
	}

	// Is the tmb different from the current key?  Try to get it and use it.  
	if (!isEmpty(coze.pay.tmb) && (isEmpty(CozeKey) || coze.pay.tmb !== CozeKey.tmb)) {
		if (privateMode) {
			MessageSucceedFail("verified", "Message's \"tmb\" doesn't match key's \"tmb\".", "", false);
			return false;
		}
		let err = await GetKey(coze.pay.tmb)
		if (!isEmpty(err)) {
			MessageSucceedFail("verified", err, "", false);
			return false;
		}
		return VerifyCoze(); // Start over again.

	}

	let verified = await Coze.Verify(coze, CozeKey);
	// console.debug(verified)

	ShowMeta(coze);
	validMsg = KeyLocations[CozeKey.fromLocation].verifiedMsg
	MessageSucceedFail("verified", invalidMsg, validMsg, verified);
	Highlight.HighlightCan();
	return verified;
};


/**
SignMsgGUI puts the text area string into a "msg" field in a Coze object and
signs it.
@returns {void}
 */
async function SignMsgGUI() {
	try {
		ResetGUI();
		if (Object.keys(CozeKey).length === 0) {
			throw "No key is set.  Key is needed to sign.";
		}

		let pay = {
			msg: document.getElementById("message").value,
			alg: CozeKey.alg,
			iat: Now(),
			tmb: CozeKey.tmb,
			typ: "cyphr.me/msg/create"
		};

		let coze = {
			pay: pay
		};
		await Coze.Sign(coze, CozeKey);
		document.getElementById("signedMessage").textContent = JSON.stringify(coze, null, Spaces);
		ShowMeta(coze);
		Show("signedMessageRow");
	} catch (e) {
		console.error(e);
		MessageSucceedFail("verified", e, "", false);
	}
};


/**
SignRawJSONGUI grabs the GUI input JSON, signs with minimal Coze checks, and
sets the GUI.

The resulting `coze` may be missing required Coze fields, such as iat, tmb, typ,
and alg.
@returns {void}
 */
async function SignRawJSONGUI() {
	try {
		ResetGUI();
		var coze = {};
		let obj = JSON.parse(document.getElementById("message").value);

		if (Array.isArray(obj)) { // Is the message an array?
			coze = [];
			for (let i = 0; i < obj.length; i++) {
				let signed = await signRawJSON(obj[i]);
				coze.push(signed);
			}
		} else { // Not an array
			coze = await signRawJSON(obj);
		}
		console.debug(coze)

		// Double check if the signed verifies. 
		let valid = await Coze.VerifyCozeArray(coze, CozeKey);
		if (!valid) {
			throw new Error("Coze.SignRawJSONGUI: Invalid Coze");
		}
		// Everything passed.  Set GUI.
		document.getElementById("signedMessage").textContent = JSON.stringify(coze, null, Spaces);
		ShowMeta(coze);
		Show("signedMessageRow");
	} catch (e) {
		console.error(e);
		MessageSucceedFail("verified", "Unable to sign JSON: " + e, "", false);
		return;
	}
};


/**
signRawJSON signs input object or JSON string and puts it in a `coze` object.

The resulting `coze` may be missing required coze fields, such as `alg`,`iat`,
and `tmb`. This function may return an cryptographically valid, but coze
invalid, object.

Input var "coze" may or may not be `pay` wrapped e.g. `"pay":{...}` or coze
wrapped e.g. "coze":{"pay":{...},"sig":"..."}

Output is always pay wrapped regardless of input.

If input is coze wrapped, output will be coze wrapped.

Throws error if `coze` is array.  (Use `SignRawJSONGUI` for arrays.)
@param   {(coze|string)} coze   Stringed JSON object to be signed.
@returns {coze}                 Coze returned from signing the message. Empty if invalid.
@throws  {SyntaxError}          JSON parse exception.
 */
async function signRawJSON(coze) {
	if (isEmpty(CozeKey)) {
		throw new Error("signRawJSON: Private key not set.  Cannot sign message.");
	}
	if (Array.isArray(coze)) {
		throw new Error("signRawJSON: Input cannot be array.");
	}
	if (typeof coze == "string") {
		coze = JSON.parse(coze);
	}

	// "coze" encapsulated?  Unencapsulate and re-wrap after signing.
	if (coze.hasOwnProperty("coze")) {
		var cozeWrap = true;
		coze = coze.coze;
	}

	// If there is no pay, assume input is pay and encapsulate into a pay. 
	if (isEmpty(coze.pay) && Object.keys(coze).length !== 0) {
		coze = {
			pay: coze
		};
	}

	// Don't allow signing revoke messages when option is checked/true
	if (dontSignRevoke) {
		if (!isEmpty(coze.pay.rvk)) {
			throw new Error("signRawJSON: The message contains \"rvk\". (To sign, allow signing revoke messages.)");
		}
	}

	if (updateIat && !isEmpty(coze.pay.iat)) {
		console.log("in");
		coze.pay.iat = Math.floor(Date.now() / 1000); // To get Unix from js, divide by 1000.
	}

	await Coze.SignCozeRaw(coze, CozeKey);

	if (cozeWrap) { // rewrap in a "coze" if given was wrapped.  
		let coze2 = {}
		coze2.coze = coze;
		coze = coze2;
	}

	return coze;
};


function ScanQRModal() {
	console.log("Start scan QR");
	scanQRModal.toggle();
	let videoElem = document.getElementById("scanQRVideo");

	const qrScanner = new QrScanner(
		videoElem,
		result => scanQRCallback(result), {
			highlightScanRegion: true,
		},
	);

	function scanQRCallback(result) {
		console.log('decoded qr code:', result, result.data);
		scanQRModal.toggle();
		document.querySelector('#keyArea').value = result.data;
		document.querySelector('#importKeyBtn').dispatchEvent(new Event('click'));
	}

	// Stop scanning when the modal is closed.  (The bootstrap modal object is
	// not the html element, so select it by ID. )
	document.getElementById('scanQRModal').addEventListener('hidden.bs.modal', event => {
		qrScanner.stop();
	});

	qrScanner.start();
}


/**
HandleFiles accepts variadic files handled by calling 2 helper functions:
uploadFile uploads the files to the database.
previewFile displays the files to the page.
@param {FileList} files    JavaScript FileList Object. Array of files.
@returns {void}            Upload/Preview are called per file.
 */
async function HandleFiles(files) {
	// Clear out existing digests:
	document.getElementById('digest_output').textContent = "";
	var fileHashes = [];

	for (let file of files) {
		fileHashes.push(await Lib.HashFile(file, selectedAlg));
	}
	// Take out of Array if just 1.
	if (fileHashes.length == 1) {
		fileHashes = fileHashes[0];
	}
	document.getElementById('digest_output').textContent = JSON.stringify({
		"digest": fileHashes
	});

	Show("digest_output");
};

/**
MessageSucceedFail shows a message in the given page element with a fail or
success message and pushes a notification. 
@param   {string}          elementID        ID of element or element.
@param   {string}          failMessage
@param   {string}          successMessage 
@param   {boolean}         pass
@param   {boolean}         [warn]           Warning instead of danger.
@returns {boolean}                          If the element was hidden.
 */
function MessageSucceedFail(elementID, failMessage, successMessage, pass, warn) {
	console.log("MessageSucceedFail");
	var e = document.getElementById(elementID);

	// Clear out any existing message
	e.innerHTML = "";
	e.classList.remove('text-success');
	e.classList.remove('text-danger');
	e.classList.remove('text-warning');

	// Fail
	if (!pass) {
		failMessage = failIcon + " " + failMessage;
		if (warn) {
			e.classList.add("text-warning");
		} else {
			e.classList.add("text-danger");
		}
		e.innerHTML = failMessage;
		App.Notification(failMessage, "error");
	} else {
		successMessage = verifiedIcon + " " + successMessage;
		// Success
		e.innerHTML = successMessage
		e.classList.add("text-success");
		App.Notification(successMessage, "success");
	}

	Show(e);
	return;
};